export default {"src":"/_next/static/media/fiche-toutou.150f9e93.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};